import VueJwtDecode from 'vue-jwt-decode'
import moment from 'moment'
import localforage from 'localforage'

export const auth = {
    state: {
        status: 'loggedOut',
        auth: {}
    },
    mutations: {
        SET_AUTH_STATUS(state, status){
            state.status = status
        }
    },
    actions: {
        checkTokenValidity({ dispatch }){
            return new Promise((resolve, reject) => {
                localforage.getItem('authUser').then((authUser) => {
                    if(authUser !== null && authUser !== undefined){
                        const headers = JSON.parse(authUser)
                        if(moment(VueJwtDecode.decode(headers.Authorization.replace('Bearer ', '')).exp, 'X').isAfter()){
                                // init sending geolocation only when logged in (sending PUT req with latlang to server with Auth jwt token)
                                dispatch('watchGeolocation')
                                resolve()
                        } else {
                            // if token expired then log out                            
                            reject('Twoja sesja wygasła, zaloguj się ponownie.')
                        }
                    } else {
                        reject('Błąd odczytu z pamięci podręcznej przeglądarki')
                    }
                })
            })
        }
    },
    getters: {
    }
}
